export default {
  semantic: {
    primary: {
      50: "#ACC5E7",
      100: "#ACC5E7",
      200: "#193471",
      300: "#193471",
      400: "#193471",
      500: "#193471",
      600: "#193471",
      700: "#193471",
      800: "#193471",
      900: "#193471",
      950: "#193471",
    },
    gray: {
      500: "#D1D5DB",
    },
  },
};
